<template>
  <ul class="fmhind-external-legend">
    <li
      v-for="(item, index) in items"
      :key="item"
      @mouseenter="() => onMouseOver(index)"
      @mouseleave="() => onMouseOver(index)"
      class="fmhind-external-legend__item"
    >
      <span
        class="fmhind-external-legend__item-color"
        :style="{
          'background-color':
            apexChartsDefaults.colors[index % apexChartsDefaults.colors.length]
        }"
      />
      <span class="fmhind-external-legend__item-text">
        {{ item.includes('ChartText') ? $t(item) : item }}
      </span>
    </li>
  </ul>
</template>

<script>
import { apexChartsDefaults } from '@/components/ChartPartials/setApexChartsDefaults';

export const ACTIONS = {
  HIGHLIGHT: 'highlight',
  TOGGLE_SERIES: 'toggleSeries'
};

export default {
  name: 'ExternalLegend',
  props: {
    items: {
      type: Array,
      required: true,
      validator: prop => prop.length > 0
    },
    actions: {
      type: [String, Array],
      required: false,
      default: ACTIONS.HIGHLIGHT,
      validator: prop => {
        const actions = Object.values(ACTIONS);
        if (Array.isArray(prop)) {
          return prop.every(item => actions.includes(item));
        } else if (typeof prop === 'string') {
          return actions.includes(prop);
        } else {
          throw new TypeError('actions must be string or Array of strings.');
        }
      }
    },
    charts: {
      type: Array,
      required: true,
      validator: prop => prop.length > 0
    }
  },
  data() {
    return {
      apexChartsDefaults
    };
  },
  methods: {
    toggleHighlight(index) {
      this.charts.forEach(chart => {
        chart.toggleDataPointSelection(index);
      });
    },
    onMouseOver(index) {
      if (this.actions.includes(ACTIONS.HIGHLIGHT)) {
        this.toggleHighlight(index);
      }
    }
    // TODO implement series toggle
  }
};
</script>

<style lang="scss">
$color-size: $unit;

.fmhind-external-legend {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.fmhind-external-legend__item {
  display: flex;
  // align-items: center;
  margin-bottom: $color-size;
  margin-right: $color-size;
}

.fmhind-external-legend__item-color {
  width: $color-size;
  height: $color-size;
  margin-right: $color-size * 0.2;
}

.fmhind-external-legend__item-text {
  @extend %text-sm;
}
</style>
